import { makeStyles } from '@rbx/ui';

const useAccessibilityStyles = makeStyles()(() => ({
  noStylesBtn: {
    // strips default button styles
    // used when e.g. button with no styles required
    // for an accessible click target
    background: 'none',
    color: 'inherit',
    border: 'none',
    padding: 0,
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    alignSelf: 'flex-start',
  },

  clickable: {
    cursor: 'pointer',
  },
}));

export default useAccessibilityStyles;
